import React from 'react';
import bem from 'utils/bem.js';
import { useRoomContext } from '../../contexts/RoomContext';
import { ClientPlaceholder } from './ClientPlaceholder';
import { SpecialistPlaceholder } from './SpecialistPlaceholder';

const { block } = bem('video-placeholder')
export const LocalVideoPlaceholder = () => {
    const { user, order } = useRoomContext();
    return user.isStaff ?
        <SpecialistPlaceholder className={block('local')} order={order} /> :
        <ClientPlaceholder className={block('local')} />
}
